import { APP_MESSAGES_ERROR } from '../../models/error-messages/error-messages.interfaces';

export const transformToMap = (
  data: APP_MESSAGES_ERROR
): Map<
  string,
  { errorMessageTitle: string; errorMessageDescription: string }
> | null => {
  const errorMap = new Map();

  try {
    data.errormessages.forEach((message) => {
      if (message.errorId) {
        errorMap.set(message.errorId, {
          errorMessageTitle: message.errorMessageTitle,
          errorMessageDescription: message.errorMessageDescription
        });
      } else {
        throw new Error();
      }
    });
    return errorMap;
  } catch (error) {
    return null;
  }
};
